import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const errors = {
  namespaced: true,
  state: {
    active: false,
    options: {},
    jsonErrors: null,
  },
  getters,
  mutations,
  actions
};
